// Just gtfo of our site and go to the google form immediately if this page is called.
export default function Priority() {
    window.location.href =
      "https://docs.google.com/forms/d/e/1FAIpQLSdlWklwBIosycBh68kLfhkgnGzY44yFMnFCadZIOdde8-Y4YA/viewform";
    return null;
  }
  